/* eslint-disable */

/** select columns of table "argo.vw_material_by_class" */
export enum ArgoVwMaterialByClassSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedLocationId = 'created_location_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  MaterialClassId = 'material_class_id',
  /** column name */
  MaterialId = 'material_id',
  /** column name */
  MaterialModelId = 'material_model_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  SerialNumber = 'serial_number',
  /** column name */
  SerialNumberActive = 'serial_number_active',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "argo_vw_material_by_class_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.vw_material_by_class" */
export enum ArgoVwMaterialByClassSelectColumnArgoVwMaterialByClassAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled',
  /** column name */
  SerialNumberActive = 'serial_number_active'
}

/** select "argo_vw_material_by_class_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.vw_material_by_class" */
export enum ArgoVwMaterialByClassSelectColumnArgoVwMaterialByClassAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled',
  /** column name */
  SerialNumberActive = 'serial_number_active'
}

